import React from 'react'

const Book = (props: any) => {
  return (
    <svg
      {...props}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
        <path
          d="M782 4467 c-50 -19 -98 -62 -121 -110 l-21 -43 0 -1540 c0 -1473 1
-1541 19 -1580 22 -49 90 -109 133 -118 17 -3 252 -6 522 -6 270 0 530 -5 578
-10 170 -20 320 -90 467 -220 l91 -81 0 1713 0 1713 -33 37 c-83 94 -235 186
-379 230 -71 22 -85 22 -648 25 -429 1 -583 -1 -608 -10z"
        />
        <path
          d="M3140 4465 c-145 -29 -298 -108 -406 -210 l-64 -60 0 -1718 0 -1718
91 81 c147 130 297 200 467 220 48 5 312 10 587 10 462 0 503 2 540 19 51 23
101 79 114 128 8 26 11 529 11 1563 l0 1525 -24 51 c-25 54 -69 94 -125 113
-51 17 -1104 14 -1191 -4z"
        />
        <path
          d="M350 4039 c-44 -18 -90 -59 -113 -102 l-22 -42 0 -1550 0 -1550 28
-48 c15 -26 47 -60 69 -75 l42 -27 950 -2 951 -2 -60 55 c-70 65 -192 128
-279 143 -37 7 -254 11 -575 11 -551 0 -589 3 -684 51 -99 51 -174 141 -209
251 -17 57 -18 126 -18 1479 l0 1419 -27 -1 c-16 0 -39 -5 -53 -10z"
        />
        <path
          d="M4688 2614 l-3 -1439 -32 -68 c-61 -128 -174 -217 -311 -246 -35 -7
-233 -11 -575 -11 -581 0 -595 -2 -718 -66 -37 -20 -94 -60 -126 -90 l-58 -53
950 2 950 2 47 32 c30 21 54 49 70 80 l23 48 0 1545 0 1545 -28 48 c-33 56
-90 97 -146 104 l-41 6 -2 -1439z"
        />
      </g>
    </svg>
  )
}

export default Book
